import {
  BaseTokenRequestHandler,
  AuthorizationServiceConfiguration,
  RevokeTokenRequest,
} from '@openid/appauth/built';

export default class CustomTokenRequestHandler extends BaseTokenRequestHandler {
  performRevokeTokenRequest(
    configuration: AuthorizationServiceConfiguration,
    request: RevokeTokenRequest
  ): Promise<boolean> {
    const revokeTokenResponse = this.requestor.xhr<boolean>({
      url: configuration.revocationEndpoint,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${request.token}`,
      },
    });

    return revokeTokenResponse.then(() => true);
  }
}
